export default __webpack_public_path__ + "static/media/emoji_party_popper.0ecb474f.png";